class RandomPartnerAdPromo {
  constructor(el) {
    this.el = el;
    var clone = this.el.cloneNode(true);
    var adsData = JSON.parse(this.el.getAttribute('data-ads'));

    this.template = `
      <div class="PartnerAdPromo">
        <div class="PartnerAdPromo-layout">
          <div class="PartnerAdPromo-imageWrapper">
            <div class="PartnerAdPromo-image js-background-image">
              <img class="PartnerAdPromo-image-src" src="" />
            </div>
          </div>
          <div class="PartnerAdPromo-content">
            <h2 class="PartnerAdPromo-title"></h2>
            <p class="PartnerAdPromo-description"></p>
            <a class="PartnerAdPromo-button btn-pill" href=""></a>
          </div>
        </div>
      </div>
    `;
    clone.innerHTML = this.template.trim();

    var randomPartnerAd = adsData[Math.floor(Math.random() * adsData.length)];
    var adPromoEl = clone.querySelector('.PartnerAdPromo');
    var titleEl = clone.querySelector('.PartnerAdPromo-title');
    var imageEl = clone.querySelector('.PartnerAdPromo-image');
    var imageSrcEl = clone.querySelector('.PartnerAdPromo-image-src');
    var descriptionEl = clone.querySelector('.PartnerAdPromo-description');
    var buttonEl = clone.querySelector('.PartnerAdPromo-button');

    // Conditionally Remove Image Element
    titleEl.innerHTML = randomPartnerAd.title;
    buttonEl.innerHTML = randomPartnerAd.cta_text;
    buttonEl.setAttribute('href', randomPartnerAd.cta_uri);
    if (randomPartnerAd.image) {
      imageSrcEl.setAttribute('src', randomPartnerAd.image.medium_src);
      imageSrcEl.setAttribute('alt', randomPartnerAd.image.alt_text || '');
      adPromoEl.classList.add('--with-image');
    } else {
      imageEl.remove();
    }

    if (randomPartnerAd.description) {
      descriptionEl.innerHTML = randomPartnerAd.description;
    } else {
      descriptionEl.remove();
    }

    this.el.replaceWith(clone);
  }
}

const RandomPartnerAdPromos = document.querySelectorAll('.PartnerAdPromo--random');

RandomPartnerAdPromos.forEach((element) => {
  new RandomPartnerAdPromo(element);
});
